var date;
function timestampToDateTimeStr(t){
    if (!t) return '';
    var a = new Date(t);// * 1000);
    return date = ('0'+a.getDate()).substr(-2)+'.'+('0' + (a.getMonth() + 1)).substr(-2) + '.' +a.getFullYear() + ' ' +
        ('0'+a.getHours()).substr(-2) + ':' + ('0'+a.getMinutes()).substr(-2) + ':' + ('0'+a.getSeconds()).substr(-2);
}
function ToDateTimeStr(t){
    if (!t) return '';
    var a = new Date(t);// * 1000);
    return date = ('0'+a.getDate()).substr(-2)+'.'+('0' + (a.getMonth() + 1)).substr(-2) + '.' +a.getFullYear();
}
export const convert = {
    timestampToDateTimeStr,
    ToDateTimeStr,
}